import { userStore, types } from "@/BaseComponent";
import { apiService, header } from "@/services/interceptor";
import { AxiosResponse } from "axios";
// import { AxiosResponse } from "axios";

export default {
    async list(param: types.ReqSubscribeList): Promise<types.ResPaging> {
        const res = {} as types.ResPaging;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post("/subscribe/list", param, { withCredentials: false });

            return response.data;
        } catch (error) {
            console.error(error);
        }
        return res;
    },

    async multiRemove(idxList: string): Promise<types.BaseResponse> {
        const res = {} as types.BaseResponse;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post("/subscribe/multi/delete", { idxList }, { withCredentials: false });

            return response.data;
        } catch (error) {
            console.error(error);
        }
        return res;
    },

    async isDone(idx: number): Promise<types.BaseResponse> {
        const res = {} as types.BaseResponse;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post("/subscribe/isDone/" + idx, null, { withCredentials: false });

            return response.data;
        } catch (error) {
            console.error(error);
        }
        return res;
    },

    async exportExcel(param: types.ReqSubscribeForExcel): Promise<any> {
        let res = {} as types.BaseResponse;
        try {
            header.headers["Content-Type"] = "application/json";
            const response: AxiosResponse<Blob> = await apiService().post("/subscribe/excel/download", param, {
                withCredentials: false,
                responseType: "blob",
            });

            return response;
        } catch (error: any) {
            console.error(error);
            res = error.response.data;
        }
        return res;
    },
};
